import { CL_META, CL_META_MENSAL, CL_GA, CL_GA_MENSAL, CL_LINKEDIN, CL_LINKEDIN_MENSAL, CL_CONTEUDO, CL_AGENCIA, CL_ONB_ZERO, CL_ONB_MIGRACAO } from "./constants";
import { parsePlataformas } from "./plataformas";

export const uid = () => Math.random().toString(36).slice(2, 10);
export const isoToday = () => new Date().toISOString().split("T")[0];

export const curMonth = () => {
  const d = new Date();
  return `${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

export const nextMonthStr = () => {
  const d = new Date();
  d.setMonth(d.getMonth() + 1);
  return `${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
};

export const fmtDate = (d) =>
  d ? new Date(d + "T12:00:00").toLocaleDateString("pt-BR", { day: "2-digit", month: "short" }) : "—";

export const fmtMes = (m) => {
  if (!m) return "—";
  const [mo, yr] = m.split("/");
  const nms = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
  return `${nms[parseInt(mo, 10) - 1]} ${yr}`;
};

export const fmtCurr = (n) =>
  n != null ? `R$ ${Number(n).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "—";

export const fmtNum = (n, dec = 2) =>
  n != null ? Number(n).toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: dec }) : "—";

export const getCurrentWeek = () => {
  const today = new Date();
  const day   = today.getDay();
  const diff  = day === 0 ? -6 : 1 - day;
  const mon   = new Date(today); mon.setDate(today.getDate() + diff);
  const sun   = new Date(mon);   sun.setDate(mon.getDate() + 6);
  const fmt   = (d) => d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
  return `${fmt(mon)}–${fmt(sun)}`;
};

/**
 * As rotinas de cada plataforma declarada.
 *
 * A chave vem do catálogo fechado (`plataformas.js`), não de substring
 * solta: era a leitura por substring que deixava "Linkedin Ads" cair em
 * nenhum ramo e o cliente passar o mês sem checklist.
 *
 * Plataforma sem entrada aqui (hoje: TikTok e GA4) simplesmente não
 * contribui itens — e o formulário do cadastro avisa isso na hora de
 * marcar a caixinha, em vez de deixar o operador descobrir no dia 1.
 */
const ROTINAS = {
  meta_ads: [
    [CL_META,             "Meta Ads — Rotina Semanal"],
    [CL_META_MENSAL,      "Meta Ads — Mensal"],
  ],
  google_ads: [
    [CL_GA,               "Google Ads — Rotina Semanal"],
    [CL_GA_MENSAL,        "Google Ads — Mensal"],
  ],
  linkedin_ads: [
    [CL_LINKEDIN,         "LinkedIn Ads — Rotina Semanal"],
    [CL_LINKEDIN_MENSAL,  "LinkedIn Ads — Mensal"],
  ],
};

export function buildChecklist(notes = "", type = "") {
  const n = notes.toLowerCase();
  const tp = type.toLowerCase();
  const items = [];
  // aceita item string ("Avaliar CPC") ou objeto ({ text, oque, porque })
  const push = (list, group) => list.forEach((i) => {
    const it = typeof i === "string" ? { text: i } : i;
    items.push({ id: uid(), group, text: it.text, oque: it.oque || "", porque: it.porque || "", done: false });
  });
  if (tp === "interno" || n.includes("instagram") || n.includes("social") || n.includes("conteúdo")) {
    push(CL_CONTEUDO, "Conteúdo Instagram");
    push(CL_AGENCIA,  "Operação da Agência");
  }
  for (const value of parsePlataformas(notes).values) {
    for (const [lista, grupo] of ROTINAS[value] || []) push(lista, grupo);
  }
  return items;
}

// cenario: "zero" (nunca anunciou) | "migracao" (veio de gestão anterior)
export function buildOnboardingChecklist(cenario = "zero") {
  const lst   = cenario === "migracao" ? CL_ONB_MIGRACAO : CL_ONB_ZERO;
  const group = cenario === "migracao" ? "Onboarding — Migração de Gestão" : "Onboarding — Conta do Zero";
  return lst.map((i) => ({ id: uid(), group, text: i.text, oque: i.oque || "", porque: i.porque || "", done: false }));
}
